import { LuceraBlotterItem } from '@/model/blotters';
import Divider from '../common/Divider';
import LuceraAmendOrderForm from '../form/LuceraAmendOrderForm';
import Modal, { ModalClose, ModalHeader, ModalProps, ModalTitle } from './Modal';

interface LuceraAmendOrderModalProps extends ModalProps {
    order: LuceraBlotterItem;
    onCancelOrder: (order: LuceraBlotterItem) => void;
}

const LuceraAmendOrderModal = (props: LuceraAmendOrderModalProps) => {
    const { order, handlers, onCancelOrder } = props;

    return (
        <Modal {...props} className="lg:h-auto" size="max-w-xl">
            <ModalHeader>
                <ModalTitle>Amend Order</ModalTitle>
                <ModalClose handlers={handlers} />
            </ModalHeader>
            <Divider />
            <LuceraAmendOrderForm order={order} handlers={handlers} onCancelOrder={onCancelOrder} />
        </Modal>
    );
};

export default LuceraAmendOrderModal;
